import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import {
    FormControlLabel, Checkbox,
    FormGroup, List, ListItem, Typography
} from '@mui/material';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import axiosInstance from '../../../../lib/axios';
import { formatDeleteErrorMessage } from '../../../../GlobalFunction/ErrorMessageHelper';
import UnLock from '../../../../GlobalFunction/UnLock';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const CustomTextField = styled(TextField)(({ theme }) => ({
    '& .MuiFilledInput-root': {
        backgroundColor: 'transparent',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
    },
    '& .Mui-focused': {
        borderColor: '#673ab7',
    },
    '& .MuiFilledInput-root.Mui-focused': {
        border: '1px solid #673ab7',
    },
}));

const columns = [
    { id: 'RowNum', label: 'Sr.No.', minWidth: 170 },
    { id: 'PlanName', label: 'Plan Name', minWidth: 100 },
    { id: 'PlanTenur', label: 'Tenur', minWidth: 100 },
    { id: 'FreeMonth', label: 'FreeMonth', minWidth: 100 },
    { id: 'LastAdjMonths', label: 'AdjustMonths', minWidth: 170 },
    { id: 'MinAdjMonths', label: 'MinAdjMonths', minWidth: 170 },
    { id: 'BalChargMonth', label: 'BalChargMonth', minWidth: 170 },
    { id: 'DepositAmt', label: 'DepositAmt', minWidth: 100 },
    { id: 'TotalInstall', label: 'TotalInstall', minWidth: 100 },
    { id: 'IncRentPerc', label: 'IncRentPerc', minWidth: 100 },
    { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const RoomPlanMaster = () => {
    const [formData, setFormData] = useState({
        DBFLAG: '',
        PlanName: '',
        PlanTenur: '',
        FreeMonth: '',
        BillMonthCycl: '',
        LastAdjMonths: '',
        MinAdjMonths: '',
        BalChargMonth: '',
        IncRentPerc: '',
        DepositAmt: '',
        TotalInstall: '',
        Status: '',
        Remark: '',
        CreatedBy: '1',
        EntityRoomPlandtl: [{
            RoomPlanId: "",
            PropId: ""
        }],
    });

    // const permissions = useModulePermissions("Payment Plan Master");

    const [error, setError] = useState({
        PropName: false
    });

    const navigate = useNavigate();

    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [location, setLocation] = useState(useLocation());
    const [currentRoomPlanID, setCurrentRoomPlanID] = useState(null);
    const [mode, setMode] = useState('view');
    const [property, setProperty] = useState([]);
    const [Status, setStatus] = useState("1");
    const [lastInsertedRoomPlanID, setLastInsertedRoomPlanID] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedPropIds, setSelectedPropIds] = useState([]);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const planNameRef = useRef(null);
    const planTenurRef = useRef(null);
    const freeMonthRef = useRef(null);
    const lastAdjMonthsRef = useRef(null);
    const minAdjMonthsRef = useRef(null);
    const balChargMonthRef = useRef(null);
    const DepositAmtRef = useRef(null);
    const IncRentPercRef = useRef(null);
    const totalInstallRef = useRef(null);
    const BillMonthCyclRef = useRef(null);
    const remarkRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.RoomPlanID) {
            setCurrentRoomPlanID(location.state.RoomPlanID);
            fetchRoomPlanData(location.state.RoomPlanID, "R");
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
            fetchProperty(-1);
        }
    }, [location]);

    const fetchRoomPlanData = async (id, flag) => {
        try {
            const response = await axios.post(`MstRoomPlan/RetriveMstRoomPlan`, {
                RoomPlanID: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const roomPlanData = response.data.Data[0];
                setFormData({
                    RoomPlanID: roomPlanData.currentRoomPlanID,
                    DBFLAG: currentRoomPlanID ? 'U' : 'A',
                    PlanName: roomPlanData.PlanName || '0',
                    PlanTenur: roomPlanData.PlanTenur || '0',
                    FreeMonth: roomPlanData.FreeMonth || '0',
                    LastAdjMonths: roomPlanData.LastAdjMonths || '0',
                    MinAdjMonths: roomPlanData.MinAdjMonths || '0',
                    BalChargMonth: roomPlanData.BalChargMonth || '0',
                    BillMonthCycl: roomPlanData.BillMonthCycl || 0,
                    IncRentPerc: roomPlanData.IncRentPerc || '0',
                    DepositAmt: roomPlanData.DepositAmt || '0',
                    TotalInstall: roomPlanData.TotalInstall || '0',
                    Status: roomPlanData.Status || '1',
                    Remark: roomPlanData.Remark || '',
                    CreatedBy: roomPlanData.CreatedBy ? roomPlanData.CreatedBy.toString() : '1',
                });
                setStatus(roomPlanData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentRoomPlanID(roomPlanData.RoomPlanID);

                fetchProperty(roomPlanData.RoomPlanID);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.error('Failed to fetch RoomPlan Data');
            }
        } catch (error) {
            toast.error('Error fetching RoomPlan Data. Please try again.');
        }
    };

    const fetchEntityRoomPlandtlData = async (id, PropertyData) => {
        try {
            const response = await axios.post('MstRoomPlan/GetMstRoomPlandtlDashboard', {
                RoomPlanID: parseInt(id)
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const roomPlanData = response.data.Data;
                var newPropData = PropertyData.map(obj => {
                    let index = roomPlanData.findIndex(Iobj => Iobj.PropId === obj.Id);

                    if (index >= 0) {
                        return { ...obj, isChecked: true }
                    } else {
                        return { ...obj, isChecked: false }
                    }
                })

                setProperty(newPropData);

                const allChecked = newPropData.every((item) => item.isChecked);
                setSelectAll(allChecked);

            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
                fetchProperty(-1);

            } else {
                toast.error('Failed to fetch EntityRoomPlandtl Data');
            }
        } catch (error) {
            toast.error('Error fetching EntityRoomPlandtl Data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 1,
                PageSize: 1,
                SearchText: ""
            };

            try {
                const res = await axios.post('MstRoomPlan/getAllMstRoomPlanDashBoard', { params });

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (err) {
                toast.error('Error fetching data:', err);
            }
        };
        getRow();
    }, []);

    const fetchProperty = async (Id) => {
        const Flag = "";
        try {
            const response = await axios.post(`PropertyMst/GetPropertyMstUserwisedrp`,
                { Flag, UserId }
            );
            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                if (Id === -1) {
                    setProperty(response.data.Data);
                } else {
                    fetchEntityRoomPlandtlData(Id, response.data.Data);
                }
            } else {
                toast.error("Failed to fetch Property");
            }
        } catch (error) {
            toast.error("Error fetching Property. Please try again.");
        }
    };

    const handlePrevious = async () => {
        if (currentRoomPlanID && currentRoomPlanID > 1) {
            await fetchRoomPlanData(currentRoomPlanID, "P");
        }
    };

    const handleNext = async () => {
        if (currentRoomPlanID) {
            await fetchRoomPlanData(currentRoomPlanID, "N");
        }
    };

    const calculateTotalInstallment = (balChargMonth, billMonthCycl) => {
        const a = parseFloat(balChargMonth);
        const b = parseFloat(billMonthCycl);

        if (!isNaN(a) && !isNaN(b) && b !== 0) {
            const result = (a / b) + 1;
            return Math.round(result);
        }
        return '';
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (name === 'RoomPlan') {
            setFormData(prevState => ({
                ...prevState,
                state: ''
            }));
        }

        if (name === 'RoomPlan' && value !== '') {
            setTimeout(() => {
                remarkRef.current.focus();
            }, 100000);
        }

        if (name === 'PlanTenur' && Number(value) > 12) {
            toast.error("Tenure cannot be more than 12.");
            return;
        }

        if (name === 'MinAdjMonths') {
            const minAdjMonths = Number(value);
            const planTenure = Number(formData.PlanTenur);

            if (planTenure && minAdjMonths > planTenure) {
                toast.error("Minimum Advance Months can't be more than Tenure.");
                return;
            }
        }

        setFormData(prevFormData => {
            const newFormData = {
                ...prevFormData,
                [name]: value
            };

            // Update BalChargMonth and TotalInstall
            if (name === 'PlanTenur' || name === 'FreeMonth' || name === 'MinAdjMonths') {
                const planTenur = parseFloat(newFormData.PlanTenur);
                const freeMonth = parseFloat(newFormData.FreeMonth);
                const minAdjMonths = parseFloat(newFormData.MinAdjMonths);
                const billMonthCycl = parseFloat(newFormData.BillMonthCycl);

                if (!isNaN(planTenur) && !isNaN(freeMonth) && !isNaN(minAdjMonths)) {
                    const balChargMonth = planTenur - (minAdjMonths + freeMonth);
                    newFormData.BalChargMonth = balChargMonth.toString();

                    // Also update TotalInstall
                    if (!isNaN(balChargMonth) && !isNaN(billMonthCycl) && billMonthCycl !== 0) {
                        const totalInstall = calculateTotalInstallment(balChargMonth, billMonthCycl);
                        newFormData.TotalInstall = totalInstall.toString();
                    }
                }
            }

            // Auto Update TotalInstall
            if (['BalChargMonth', 'BillMonthCycl'].includes(name)) {
                const totalInstall = calculateTotalInstallment(
                    newFormData.BalChargMonth,
                    newFormData.BillMonthCycl
                );
                newFormData.TotalInstall = totalInstall.toString();
            }
            return newFormData;
        });
    };

    const handleSelectAll = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);

        const updatedItems = property.map((item) => ({
            ...item,
            isChecked: newSelectAll,
        }));

        setProperty(updatedItems);

        if (newSelectAll) {
            setSelectedPropIds(updatedItems.map(item => item.Id));
        } else {
            setSelectedPropIds([]);
        }
    };

    const handleCheckboxChange = (Id) => {
        const updatedItems = property.map((item) =>
            item.Id === Id ? { ...item, isChecked: !item.isChecked } : item
        );
        setProperty(updatedItems);

        const allChecked = updatedItems.every((item) => item.isChecked);
        setSelectAll(allChecked);
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === planNameRef.current) {
                planTenurRef.current.focus();
            } else if (event.target === planTenurRef.current) {
                freeMonthRef.current.focus();
            } else if (event.target === freeMonthRef.current) {
                lastAdjMonthsRef.current.focus();
            } else if (event.target === lastAdjMonthsRef.current) {
                BillMonthCyclRef.current.focus();
            } else if (event.target === BillMonthCyclRef.current) {
                IncRentPercRef.current.focus();
            } else if (event.target === IncRentPercRef.current) {
                minAdjMonthsRef.current.focus();
            } else if (event.target === minAdjMonthsRef.current) {
                balChargMonthRef.current.focus();
            } else if (event.target === balChargMonthRef.current) {
                DepositAmtRef.current.focus();
            } else if (event.target === DepositAmtRef.current) {
                totalInstallRef.current.focus();
            } else if (event.target === totalInstallRef.current) {
                remarkRef.current.focus();
            } else {
                remarkRef.current.focus();
            }
        }
    };

    const handleSubmit = async () => {
        let EntityData = property
            .filter(obj => obj.isChecked)
            .map(obj => ({
                "RoomPlanId": currentRoomPlanID,
                "PropId": obj.PropId
            }));

        if (EntityData.length === 0) {
            EntityData = [{
                "RoomPlanId": currentRoomPlanID,
                "PropId": 1
            }];
        }

        try {
            const payload = {
                DBFLAG: currentRoomPlanID ? 'E' : 'A',
                RoomPlanID: currentRoomPlanID ? parseInt(currentRoomPlanID) : 0,
                PlanName: formData.PlanName || '',
                PlanTenur: formData.PlanTenur || '',
                FreeMonth: formData.FreeMonth || 0,
                LastAdjMonths: formData.LastAdjMonths || 0,
                MinAdjMonths: formData.MinAdjMonths || 0,
                BillMonthCycl: formData.BillMonthCycl || 0,
                BalChargMonth: formData.BalChargMonth || 0,
                IncRentPerc: formData.IncRentPerc || 0,
                DepositAmt: formData.DepositAmt || '',
                TotalInstall: formData.TotalInstall || 0,
                Status: Status,
                Remark: formData.Remark || '',
                CreatedBy: '1',
                EntityRoomPlandtl: EntityData,
            };

            let jsonData = JSON.stringify(payload);

            jsonData = jsonData.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
            jsonData = '"' + jsonData + '"';

            let response;
            if (mode === 'edit') {
                payload.RoomPlanID = currentRoomPlanID;
                payload.UpdatedBy = parseInt(UserId, 10);
                await UnLock(currentRoomPlanID, "MstRoomPlan", "RoomPlanID");

                response = await axios.patch(`MstRoomPlan/ManageMstRoomPlan`, jsonData);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axios.post(`MstRoomPlan/ManageMstRoomPlan`, jsonData);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedRoomPlanID(response.data.Data)

                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentRoomPlanID(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            toast.error('Error saving/updating RoomPlan Data. Please try again.');
        }
    };

    const handleEdit = async () => {
        let Flag = await checkAndLock(currentRoomPlanID, "MstRoomPlan", "RoomPlanID")
        switch (Flag) {
            case 0:
                setMode("edit");
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Faled To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("something Went Wrong", { autoClose: 500 });
        }
        setIsFormDisabled(false);
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            DBFLAG: '',
            PlanName: '',
            PlanTenur: '',
            FreeMonth: '',
            LastAdjMonths: '',
            MinAdjMonths: '',
            BalChargMonth: '',
            BillMonthCycl: '',
            IncRentPerc: '',
            DepositAmt: '',
            TotalInstall: '',
            Status: '',
            Remark: '',
            CreatedBy: '1',
            EntityRoomPlandtl: [{
                RoomPlanId: "",
                PropId: ""
            }],
        });
        setCurrentRoomPlanID(null);

        setProperty(PropertyData => PropertyData.map(obj => ({
            ...obj,
            isChecked: false
        })));

        setTimeout(() => {
            planNameRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchRoomPlanData(1, "L");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const handleExit = () => {
        navigate('/roomPlanTable')
    };

    const handleNavigateLink = () => {
        navigate('/roomPropertyList-table')
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        let Flag = await checkAndLock(currentRoomPlanID, "MstRoomPlan", "RoomPlanID");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchRoomPlanData(currentRoomPlanID, "D");
                await fetchRoomPlanData(currentRoomPlanID, "N");
                setMode('view');
                setIsFormDisabled(true);
                break;
            case 1: toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default: toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    return (
        <>
            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentRoomPlanID || currentRoomPlanID === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentRoomPlanID}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Payment Plan Master
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Payment Plan Master"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}
                        sx={{
                            marginInline: "10px",
                            maxHeight: "50vh",
                            marginBlock: "10px",
                        }}
                    >
                        <Grid container spacing={1}>
                            <Grid item lg={8} md={8} xs={12}>
                                <Box display="flex" flexDirection="column" gap={1}>
                                    <Grid item lg={12} md={12} xs={12}>
                                        <Box display="flex" flexDirection="column" gap={1}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={6} lg={6} className="form_field">
                                                    <TextField
                                                        id="PlanName"
                                                        name="PlanName"
                                                        label={
                                                            <span>
                                                                Plan Name<span style={{ color: "red" }}>*</span>
                                                            </span>
                                                        }
                                                        variant="filled"
                                                        fullWidth
                                                        className="custom-textfield"
                                                        value={formData.PlanName}
                                                        onChange={handleInputChange}
                                                        disabled={isFormDisabled}
                                                        inputRef={planNameRef}
                                                        onKeyDown={handleKeyPress}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} lg={6}>
                                                    <TextField
                                                        id="PlanTenur"
                                                        name="PlanTenur"
                                                        label={
                                                            <span>
                                                                Tenur<span style={{ color: "red" }}>*</span>
                                                            </span>
                                                        }
                                                        variant="filled"
                                                        fullWidth
                                                        className="custom-textfield"
                                                        type='number'
                                                        value={formData.PlanTenur}
                                                        onChange={handleInputChange}
                                                        disabled={isFormDisabled}
                                                        inputRef={planTenurRef}
                                                        onKeyDown={handleKeyPress}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                                id="FreeMonth"
                                                name="FreeMonth"
                                                label="Free Month"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                type='number'
                                                value={formData.FreeMonth}
                                                onChange={handleInputChange}
                                                disabled={isFormDisabled}
                                                inputRef={freeMonthRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                                id="LastAdjMonths"
                                                name="LastAdjMonths"
                                                label="Last Adjustment Month"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                type='number'
                                                value={formData.LastAdjMonths}
                                                onChange={handleInputChange}
                                                disabled={isFormDisabled}
                                                inputRef={lastAdjMonthsRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                                id="MinAdjMonths"
                                                name="MinAdjMonths"
                                                label="Minimum Advance Month"
                                                type='number'
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.MinAdjMonths}
                                                onChange={handleInputChange}
                                                disabled={isFormDisabled}
                                                inputRef={minAdjMonthsRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                                id="BalChargMonth"
                                                name="BalChargMonth"
                                                label="Balance Chargeable Month"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                type='number'
                                                value={formData.BalChargMonth}
                                                onChange={handleInputChange}
                                                disabled={true}
                                                inputRef={balChargMonthRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                                id="BillMonthCycl"
                                                name="BillMonthCycl"
                                                label="No Of Month Per Pyt Advice"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                type='number'
                                                value={formData.BillMonthCycl}
                                                onChange={handleInputChange}
                                                disabled={isFormDisabled}
                                                inputRef={BillMonthCyclRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                                id="TotalInstall"
                                                name="TotalInstall"
                                                label="Total Installment"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.TotalInstall}
                                                type='number'
                                                onChange={handleInputChange}
                                                disabled={isFormDisabled}
                                                inputRef={totalInstallRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                                id="DepositAmt"
                                                name="DepositAmt"
                                                label={
                                                    <span>
                                                        Deposit Amount<span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                type='number'
                                                value={formData.DepositAmt}
                                                onChange={handleInputChange}
                                                disabled={isFormDisabled}
                                                inputRef={DepositAmtRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                                id="IncRentPerc"
                                                name="IncRentPerc"
                                                label="Increment Rent(%)"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                type='number'
                                                value={formData.IncRentPerc}
                                                onChange={handleInputChange}
                                                disabled={isFormDisabled}
                                                inputRef={IncRentPercRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6} lg={10}>
                                            <TextField
                                                id="Remark"
                                                name="Remark"
                                                label="Remark"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.Remark}
                                                onChange={handleInputChange}
                                                disabled={isFormDisabled}
                                                inputRef={remarkRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={2}>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            disabled={isFormDisabled}
                                                            checked={Status === "1"}
                                                            onChange={handleChangeStatus}
                                                        />
                                                    }
                                                    label="Status"
                                                />
                                            </FormGroup>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item lg={4} md={4} xs={12} display="flex" alignItems="center" justifyContent="center" >
                                <div>
                                    <Link
                                        sx={{
                                            fontSize: "12px",
                                            fontWeight: 700,
                                            marginInline: "auto",
                                            width: "fit-content",
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                        onClick={handleNavigateLink}
                                    >
                                        Property Wise Plan List
                                    </Link>
                                    <Typography
                                        sx={{
                                            fontSize: "18px",
                                            fontWeight: 700,
                                            marginInline: "auto",
                                            width: "fit-content"
                                        }}
                                    >
                                        Choose Property
                                    </Typography>
                                    <List
                                        sx={{
                                            maxHeight: "40vh",
                                            minWidth: "200px",
                                            overflowX: "auto",
                                            paddingLeft: "30px",
                                        }}
                                    >
                                        <ListItem sx={{ paddingLeft: "16px" }}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    checked={selectAll}
                                                    onChange={handleSelectAll}
                                                    disabled={isFormDisabled}
                                                />
                                                All
                                            </label>
                                        </ListItem>
                                        {property.map((item) => (
                                            <ListItem
                                                key={item.Id}
                                            >
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        checked={item.isChecked}
                                                        onChange={() => handleCheckboxChange(item.Id)}
                                                        disabled={isFormDisabled}
                                                    />
                                                    {item.Name}
                                                </label>
                                            </ListItem>
                                        ))}
                                    </List>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="Payment Plan Master"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />
                }
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default RoomPlanMaster;